module.exports = __webpack_public_path__ + "static/service-5-7033295530c5a7f94064ec956ccf4ffc.png";